(function() {
  'use strict';

  angular.module('ringbaPortal').component('urlParamsWizardForm', {
    bindings: {
      currentCampaign: '<',
      queryPathMaps: '<',
      onDismiss: '&',
      onSave: '&'
    },
    controller: UrlParamsWizardFormController,
    controllerAs: 'vm',
    bindToController: true,
    templateUrl: '/scripts/components/urlparams/url-params-wizard-form.view.html'
  });

  function UrlParamsWizardFormController(
    _,
    $filter,
    accountsService,
    campaignServiceNew,
    queryPathMapService,
    toaster
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.onCreateUpdateQuery = onCreateUpdateQuery;

    function onInit() {
      vm.createNewQueryPathMap = !!vm.createNewQueryPathMap;
    }

    function onChanges(changesObj) {
      if (changesObj.queryPathMaps) {
        if (vm.queryPathMaps.length === 0) {
          vm.createNewQueryPathMap = true;
        }
      }
    }

    function onCreateUpdateQuery(queryPathMap) {
      return _linkToCampaign(queryPathMap.id).then(function () {
        toaster.pop('success', $filter('translate')('TAGS_CREATE_AND_ADD_SUCCESS'));
        vm.onSave();
        vm.onDismiss({
          $event: {
            queryPathMap: queryPathMap
          }
        });
      });
    }

    function _linkToCampaign(queryPathMapId) {
      return campaignServiceNew.link(accountsService.currentAccountId, vm.currentCampaign.id, queryPathMapId, 'qpathmaps');
    }


  }
})();
